import dayjs from 'dayjs';
import React, { ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/utils/cn';

const Footer = ({ className, ...rest }: ComponentPropsWithoutRef<'div'>) => {
  const { t } = useTranslation('footer');

  return (
    <footer className={cn('flex items-center justify-center bg-gray-100 p-4 text-center', className)} {...rest}>
      <p>
        © {dayjs().format('YYYY')} {t('allRightsReserved')}
      </p>
    </footer>
  );
};

export default Footer;
